import { render } from "./ChatPage.vue?vue&type=template&id=8695bb9a&scoped=true"
import script from "./_ChatPage.js?vue&type=script&lang=js"
export * from "./_ChatPage.js?vue&type=script&lang=js"

import "./_ChatPage.less?vue&type=style&index=0&id=8695bb9a&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8695bb9a"]])

export default __exports__